import { defineStore } from 'pinia'

import {
  AuthService,
  serviceFactory,
  TeamService,
  UserService,
  WorkspaceService,
  type ServiceStore as BasicsServiceStore,
} from '@blueprint/frontend-basics'

import {
  appId,
  backendURL,
  keycloakClientId,
  keycloakRealm,
  keycloakURL,
} from '@/helpers/config.helper.ts'
import { AdminService } from '@/services/admin.service.ts'

export const useServiceStore = defineStore('serviceStore', {
  state: () => ({}),

  getters: {
    authService(): AuthService {
      return serviceFactory.getService<AuthService>(
        'authService',
        AuthService,
        keycloakURL,
        keycloakRealm,
        keycloakClientId,
        appId,
      )
    },
    userService(): UserService {
      return serviceFactory.getService<UserService>(
        'userService',
        UserService,
        this as unknown as BasicsServiceStore,
        this.authService,
        backendURL,
      )
    },
    adminService(): AdminService {
      return serviceFactory.getService<AdminService>(
        'adminService',
        AdminService,
        this as unknown as BasicsServiceStore,
        this.authService,
        backendURL,
      )
    },
    teamService(): TeamService {
      return serviceFactory.getService<TeamService>(
        'teamService',
        TeamService,
        this as unknown as BasicsServiceStore,
        this.authService,
        backendURL,
      )
    },
    workspaceService(): WorkspaceService {
      return serviceFactory.getService<WorkspaceService>(
        'workspaceService',
        WorkspaceService,
        this as unknown as BasicsServiceStore,
        this.authService,
        backendURL,
      )
    },
    taleService(): BasicsServiceStore['taleService'] {
      return this.teamService as unknown as BasicsServiceStore['taleService']
    },
  },
})
